import { Card, CardContent, CardContentProps, CardHeader, CardHeaderProps, Divider } from '@mui/material'
import { Iconify } from 'src/components/iconify';
import CustomButton, { CustomButtonProps } from 'src/components/reusable/custom-button';
import { createLinearGradient, hexToRgbChannel } from 'src/theme/styles';

interface DashboardContainerProps {
  children?: React.ReactElement | React.ReactElement[];
  title?: string;
  icon?: string;
  isTitle?: boolean;
  isDivider?: boolean;
  headerProps?: CardHeaderProps;
  isbutton?: boolean;
  buttonProps?: CustomButtonProps; 
  contentProps?: CardContentProps;
}

export const DashboardContainer = (props: DashboardContainerProps) => {
  const { isTitle = true, isbutton = false,buttonProps,contentProps } = props;
  
  return (
    <Card sx={{ flexGrow: 1,display:'flex', flexDirection:'column' }} elevation={4}>
      {isTitle && props.title && <CardHeader
        sx={{
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
          py: 2,
          backgroundImage: (theme) => createLinearGradient(hexToRgbChannel(theme.palette.primary.light, true), hexToRgbChannel(theme.palette.primary.light, true), 0.4, 0.2, 270)
        }}
        avatar={props.icon &&
          <Iconify width={30} icon={props.icon} />
        }
        title={props.title}
        action={isbutton && <CustomButton {...buttonProps}/>}
        slotProps={{
          title: {
            variant: 'h4'
          },
          action:{
            sx:{
              alignSelf:'center'
            }
          }
        }}
        {...props.headerProps}
      />}
      {isTitle && props.title && <Divider />}
      <CardContent sx={{ p: 2, flex:1, display:'flex', flexDirection:'column' }} {...contentProps}>
        {props.children}
      </CardContent>
    </Card>
  )
}
